import React, { useContext, useEffect, useCallback } from 'react'
import { ModalContext } from '../contexts/ModalContext'
import { VideoPlayerContext } from '../contexts/VideoPlayerContext';

import './../scss/Overlay.scss'

function Overlay() {
    const {isModalActive, setIsModalActive} = useContext(ModalContext);
    const {videoPlayer} = useContext(VideoPlayerContext)
    
    
    const toogleModal = useCallback(() => {
        setIsModalActive(!isModalActive)
        if (videoPlayer !== null) videoPlayer.pause()
    }, [isModalActive, setIsModalActive, videoPlayer])

    const handleKeyDown = useCallback(e => {
        if (e.key === 'Escape') toogleModal()
    }, [toogleModal])

    useEffect(() => {
        const body = document.querySelector('body')
        const bodyElClassList = body.classList;
        const contentWrapperEl = document.querySelector('.content-wrapper');
        
        
        if (isModalActive) {
            if (!bodyElClassList.contains('no-scroll')) bodyElClassList.add('no-scroll');
            
            body.addEventListener('keydown', handleKeyDown, {
                once: true,
            })
            
            setTimeout(() => {
                contentWrapperEl.style.overflow = 'hidden'
                contentWrapperEl.setAttribute('aria-hidden', 'true')
                contentWrapperEl.setAttribute('inert', 'true')
                            
            }, 100)  
        } else {
            if (bodyElClassList.contains('no-scroll')) bodyElClassList.remove('no-scroll');

            setTimeout(() => {
                contentWrapperEl.style.overflow = 'auto'
                contentWrapperEl.removeAttribute('aria-hidden')
                contentWrapperEl.removeAttribute('inert')
            }, 100)
        }
    }, [isModalActive, handleKeyDown])
    

    return (
        <div className={isModalActive ? `overlay overlay--active` : `overlay`} onClick={toogleModal} onKeyDown={handleKeyDown}></div>
    )
}

export default Overlay
